import { KeywordsBreakdownWidget } from "../keywords-breakdown-widget";
import { SearchTrendsMetricCards } from "../search-trends-metric-cards/SearchTrendsMetricCards";
import { KEYWORDS_BREAKDOWN_SCROLL_ID } from "../search-trends-metric-cards/shared/scrollToKeywordsBreakdown";
import { SearchVolumeOverTimeWidget } from "../search-volume-over-time-widget";
import { TrafficByCountry } from "../traffic-by-country";

import { DemandOverTime } from "./demand-over-time/DemandOverTime";

const SearchTrendsAiTopic = () => {
    return (
        <>
            <SearchTrendsMetricCards />
            <SearchVolumeOverTimeWidget />
            <TrafficByCountry />
            <DemandOverTime />
            <div id={KEYWORDS_BREAKDOWN_SCROLL_ID}>
                <KeywordsBreakdownWidget />
            </div>
        </>
    );
};

export default SearchTrendsAiTopic;
